import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-2xl font-semibold" style={{ fontFamily: "'Poppins', sans-serif" }}>
          Loading...
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/partner" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (user.role === 'expert') {
      return <Navigate to="/dashboard/expert" replace />;
    } else if (user.role === 'maverick') {
      return <Navigate to="/dashboard/maverick" replace />;
    } else if (user.role === 'guardian') {
      return <Navigate to="/dashboard/guardian" replace />;
    }
    return <Navigate to="/partner" replace />;
  }

  return children;
};